import Watched from './Watched'

export default Watched